import {
  DISTANCE_UNITS,
  convertDistanceToFeet
} from './distanceUnits';

const STORAGE_KEY = 'placepledge_default_location_radius';

export const DEFAULT_LOCATION_RADIUS = {
  value: DISTANCE_UNITS.feet.defaultValue,
  unit: 'feet'
};

const normalizeRadiusSettings = (settings) => {
  const unit = DISTANCE_UNITS[settings?.unit] ? settings.unit : DEFAULT_LOCATION_RADIUS.unit;
  const value = String(settings?.value ?? DISTANCE_UNITS[unit].defaultValue);
  const requiredDistance = convertDistanceToFeet(value, unit);

  if (!requiredDistance) {
    return {
      ...DEFAULT_LOCATION_RADIUS,
      requiredDistance: convertDistanceToFeet(DEFAULT_LOCATION_RADIUS.value, DEFAULT_LOCATION_RADIUS.unit)
    };
  }

  return {
    value,
    unit,
    requiredDistance
  };
};

export const loadDefaultLocationRadius = () => {
  try {
    const rawSettings = window.localStorage.getItem(STORAGE_KEY);

    if (!rawSettings) {
      return normalizeRadiusSettings(DEFAULT_LOCATION_RADIUS);
    }

    return normalizeRadiusSettings(JSON.parse(rawSettings));
  } catch (error) {
    return normalizeRadiusSettings(DEFAULT_LOCATION_RADIUS);
  }
};

export const saveDefaultLocationRadius = (settings) => {
  const normalizedSettings = normalizeRadiusSettings(settings);

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
      value: normalizedSettings.value,
      unit: normalizedSettings.unit
    }));
  } catch (error) {
    // Keep the in-memory setting even when localStorage is unavailable.
  }

  return normalizedSettings;
};
